import { useEffect, useState } from "react";
import { divisionInfo, divisionOrder } from "../data";
import styled from "styled-components";
import Profile from "../../common/Profile";
import { CheckBox } from "devextreme-react";
import axios from "axios";

const DivBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin-bottom: 16px;
  > div:first-child {
    width: calc(100% - 8px);
    height: 5px;
    border-radius: 2px;
    background-color: ${(props) => props.barColor};
  }
  > div:nth-child(2) {
    display: flex;
  }
`;

const JDBox = styled.div`
  display: flex;
  flex-direction: column;
  margin: 4px;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  > div:first-child {
    font-weight: 600;
    font-size: 0.8em;
    text-align: center;
    white-space: nowrap;
    padding: 4px;
  }
  > div:last-child {
    border-radius: 10px;
    padding: 4px;
    // background-color: #d9d9d9;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 60px;
    min-height: 60px;
    > div {
      margin: 0px 1px;
    }
  }
`;

const ParticipantsList = ({ contrNo, yearMonth }) => {
  const [psDataSource, setPsDataSource] = useState(null);
  const [showUnblind, setShowUnblind] = useState(false);

  useEffect(() => {
    //* formatted data
    //* {"CO Manager":["22040103"],"CPM":["22060701","22040103"],
    //* "CRA":["22060701","23020102"],"CTA":[],"DM Manager":["22040104","99999904"],
    //* "DPM":["23010201"],"DRM":["22060702","99999909"],"MW":[],"MW Manager":["22040102"],
    //* "PV Manager":[],"PVA":[],"SA":["22040105","23010202"],"SA Manager":["22040105"]}
    axios.get(`${process.env.REACT_APP_BECCO_API_URL}/api/prjAsgmt/${contrNo}?yearMonth=${yearMonth}`).then((res) => {
      const { formData, roleList } = res.data;
      // 역할 문자열을 배열로 변환
      const roleNames = roleList.role?.split(",");
      // 각 역할에 해당하는 데이터를 배열로 포맷하여 객체에 저장
      const formattedRoleData = roleNames?.reduce((result, roleName) => {
        result[roleName] = formData && formData[roleName] ? formData[roleName].split(",") : [];
        return result;
      }, {});
      setPsDataSource(formattedRoleData);
    });
  }, [contrNo, yearMonth]);

  const handleClickCheckBox = () => {
    setShowUnblind(!showUnblind);
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", margin: "15px 0px 8px 0px" }}>
        <h3 style={{ margin: "0px 16px 0px 0px", fontSize: "1em" }}>Assigned List</h3>
        <CheckBox defaultValue={showUnblind} onValueChanged={handleClickCheckBox} text="Unblind" />
      </div>
      <div style={{ display: "flex", width: "100%", maxWidth: "99vw", flexWrap: "wrap" }}>
        {psDataSource &&
          divisionOrder.map((div, idx) => {
            return (
              <DivBox key={idx} barColor={divisionInfo[div].color}>
                <div />
                <div>
                  {divisionInfo[div].jd.map((jd) => {
                    const isUnblind = jd.includes("Unblind");
                    if ((isUnblind && showUnblind) || !isUnblind) {
                      if (psDataSource[jd]) {
                        return (
                          <JDBox key={jd}>
                            <div>{jd}</div>
                            <div>
                              {psDataSource[jd].map((employeeNo) => (
                                <Profile key={employeeNo} employeeNo={employeeNo} />
                              ))}
                            </div>
                          </JDBox>
                        );
                      }
                    }
                  })}
                </div>
              </DivBox>
            );
          })}
      </div>
    </>
  );
};

export default ParticipantsList;
